export default __webpack_public_path__ + "static/media/6_Aktionen der Kampagne Legalisierung Jetzt.f02314ab.pdf";